export enum SessionTypeDisplay {
  VIDEO = 'Video',
  IN_PERSON = 'In-person'
}
